export default __webpack_public_path__ + "static/media/RIDE4.80ea76df.jpg";